import React, { useEffect } from 'react'
import Browsebanner from './Browsebanner'

import Evolve from '../landing/Evolvetomi/Evolve'
import Footer from '../landing/footer/Footer'
import Workbuild from './Workbuild'
import Benfitsbuild from './Benfitsbuild'
import Faqsbuildpath from './faqsbuildgroup/Faqsbuildpath'
import GetappBuild from '../Chatandpay/getapp/GetappBuildGroup'


const Buildgroup = () => {
  useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
    useEffect(() => {
        document.title = "Build Groups - tomi";
      }, []);
  return (
    <>
      <Browsebanner />
      <Benfitsbuild />
      <Workbuild />
      <Faqsbuildpath/>
      <Evolve />
      <GetappBuild />
      <Footer />
    </>
  )
}

export default Buildgroup